import { ChevronRight, Store } from "@/components/ui/icons";
import { Pressable, Text } from "react-native";

import { useThemeColors } from "@/theme/theme";

/**
 * The table page's way up to the vendor's whole shop (ADR-0138), where the shop's
 * `LiveTableBanner` is the way down. A link, not a tab: it opens another page.
 */
export function WholeShopLink({ onPress }: { onPress: () => void; }) {
  const c = useThemeColors();
  return (
    <Pressable
      testID="whole-shop-link"
      onPress={onPress}
      accessibilityRole="link"
      accessibilityLabel="See this vendor's whole shop"
      className="min-h-11 flex-row items-center gap-1.5 self-start"
    >
      <Store size={16} color={c.primary} aria-hidden />
      <Text className="font-label text-sm text-primary">Whole shop</Text>
      <ChevronRight size={16} color={c.primary} aria-hidden />
    </Pressable>
  );
}
